import { CustomTooltip, IconButton } from '@/shared/ui/components';
import { StudyTypeFormatter } from '@/entities/study';
import classNames from 'classnames';
import _ from 'lodash';
import { WarningLine } from '../../warningLine';
import { useColumnWithActionFormatter } from './useColumnWithActionFormatter';
import type { ColumnWithActionFormatterProps } from './columnWithActionFormatter.types';

const EMPTY_ARRAY: any[] = [];

const ColumnWithActionFormatter = ({
  rowIndex,
  text = '',
  icons = EMPTY_ARRAY,
  conflictUsers = EMPTY_ARRAY,
  isFollowOnStudy = false,
  formatter,
}: ColumnWithActionFormatterProps) => {
  const { idRef } = useColumnWithActionFormatter();

  return (
    <div className="column-with-action-container">
      <div className="column-content">
        {formatter || (
          <StudyTypeFormatter studyType={text as any} isFollowOnStudy={isFollowOnStudy} />
        )}
      </div>

      <div id={`action-button-row-${rowIndex}`} className="action-button-row">
        {_.map(icons, (icon, index) => (
          <div key={`${icon.id}-${index}`} id={`${icon.id}-${index}`}>
            <CustomTooltip title={icon.name} placement="bottom">
              <div>
                <IconButton
                  className={classNames(
                    index > 0 ? 'ml3' : '',
                    icon.isConflictButton ? '--conflict' : '',
                    icon.isCanNotEdit ? '--disabled' : '',
                  )}
                  isFilledGradient
                  disabled={icon.disabled}
                  iconComponent={<img src={icon.image} alt={icon.imageAlternate} />}
                  onClick={icon.isCanNotEdit ? undefined : icon.handleClick}
                  isIconLinkButton={icon.isIconLinkButton}
                  link={icon.isCanNotEdit ? '#' : icon.link}
                  isLoading={icon.isLoading}
                  target={icon.target}
                  id={`${idRef.current}-${index}`}
                  aria-label={icon.name}
                />
              </div>
            </CustomTooltip>
          </div>
        ))}
      </div>

      {!!conflictUsers.length && (
        <WarningLine
          id={`info-warning-${rowIndex}`}
          isReportsPage
          conflictUsers={conflictUsers}
          limitUserCount={3}
        />
      )}
    </div>
  );
};

export default ColumnWithActionFormatter;
